import { render } from "./Navbar.vue?vue&type=template&id=621f135a&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=621f135a&scoped=true&lang=css"
import "./Navbar.vue?vue&type=style&index=1&id=621f135a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621f135a"]])

export default __exports__